import { useEffect, useState } from 'react'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { useChattingTabs } from '@/modules/chatting/state/tabs-provider'

import { DialogProps } from '../types'
import { MobileTabItem } from './MobileTabItem'

export const MobileTabsDialog = ({ isOpen, onClose }: DialogProps) => {
  const {
    openNewTab,
    isTabsLimitReached,
    tabs,
    changeActiveTab,
    activeTabIndex,
  } = useChattingTabs()
  const [activeTabRef, setActiveTabRef] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (activeTabRef) {
      activeTabRef.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    }
  }, [activeTabRef])

  const handleClickAddTab = () => {
    openNewTab()
    onClose()
  }

  const handleClickTab = (index: number) => {
    changeActiveTab(index)
    onClose()
  }

  return (
    <Dialog
      bigDialog
      show={isOpen}
      onClose={onClose}
      panelClassName="py-8 px-6 sm:py-8 max-w-[340px]"
      closeIconClassName="top-10 right-8"
      className="md:hidden"
    >
      <div className="space-y-6">
        <Dialog.Header>
          <Dialog.Title className="text-left text-3xl">Tabs</Dialog.Title>
        </Dialog.Header>
        <div className="max-h-[368px] overflow-auto">
          <div className="space-y-1 pr-2">
            {tabs.map((tab, index) => (
              <MobileTabItem
                index={index}
                key={index} // eslint-disable-line react/no-array-index-key
                tab={tab}
                onClick={() => handleClickTab(index)}
                setActiveElementRef={(ref: HTMLDivElement | null) => {
                  if (activeTabIndex === index && ref && !activeTabRef) {
                    setActiveTabRef(ref)
                  }
                }}
              />
            ))}
          </div>
        </div>
        <Button
          disabled={isTabsLimitReached}
          onClick={handleClickAddTab}
          className="w-full"
        >
          Add tab
        </Button>
      </div>
    </Dialog>
  )
}
